/*!
 * cf-calc-fixes.js  — Click Fencing calculator patch bundle
 * ---------------------------------------------------------------------------
 * A single, globally-loaded, self-installing patch file for the fence
 * calculators and the quote-to-cart flow. Each fix is page/context-guarded and
 * idempotent, so loading this everywhere is safe and cheap.
 *
 * Loaded once from snippets/meta-tags.liquid (defer). Add new fixes as small
 * modules below rather than editing the ~700 KB calculator bundles.
 *
 *   Bug 2  — Blade: Quote Breakdown rendered twice. Hide the legacy stray
 *            #breakdown-content inside the Configure-step breakdown.
 *   Bug 3  — PerfMesh: block advancing past an invalid ("too short") section.
 *   Bug 4  — Cart header count showed the penny-quantity of the "Quote Total"
 *            line (e.g. "563,844 items"). Display each Quote-Total line as one
 *            quote so the header reads sensibly. Purely cosmetic — the line
 *            quantity that carries the price is never modified.
 *   Bug 5  — Calculator "Add to Cart" button hidden when DIY pre-selected.
 *   Bug 6  — Glass: ask Section Length before Spigot / Mount Type.
 *   Bug 7  — PerfMesh: show "Panel Kits" first in the breakdown.
 *   Bug 8  — Blade: show gate height in the breakdown gate line.
 * ---------------------------------------------------------------------------
 */
(function () {
  "use strict";

  var path = (location.pathname || "").toLowerCase();
  function on(slug) { return path.indexOf(slug) !== -1; }

  function injectStyle(id, css) {
    if (document.getElementById(id)) return;
    var s = document.createElement("style");
    s.id = id;
    s.type = "text/css";
    s.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(s);
  }

  // ── Bug 2: Blade duplicate Quote Breakdown ────────────────────────────────
  if (on("/pages/blade-fence-calculator")) {
    injectStyle(
      "cf-fix-blade-dedupe",
      ".quote-breakdown > #breakdown-content{display:none !important;}"
    );
  }

  // ── Bug 3: PerfMesh — block advancing past an invalid section ──────────────
  if (on("/pages/perfmesh-fence")) {
    var INVALID_RE = /too short|too small|cannot be built|won'?t fit|no panels fit/i;

    injectStyle(
      "cf-fix-perfmesh-invalid-style",
      ".cf-invalid-flash{outline:2px solid #dc2626 !important;outline-offset:4px;border-radius:8px;transition:outline-color .2s;}"
    );

    function invalidPreview() {
      var pv = document.querySelectorAll(".visual-preview");
      for (var i = 0; i < pv.length; i++) {
        var p = pv[i];
        if (p.offsetParent !== null && INVALID_RE.test(p.textContent || "")) return p;
      }
      return null;
    }
    function onConfigureStep() {
      var active = document.querySelector(".tab-content.active");
      return active && active.id === "configure-sections";
    }
    document.addEventListener(
      "click",
      function (e) {
        var next = e.target && e.target.closest ? e.target.closest("#nav-next") : null;
        if (!next) return;
        if (!onConfigureStep()) return;
        var bad = invalidPreview();
        if (!bad) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        try {
          bad.scrollIntoView({ behavior: "smooth", block: "center" });
          bad.classList.add("cf-invalid-flash");
          setTimeout(function () { bad.classList.remove("cf-invalid-flash"); }, 1600);
        } catch (_) {}
      },
      true
    );
  }

  // ── Bug 8: Blade — show gate HEIGHT in the breakdown gate line ─────────────
  // The gate line reads only its width ("Gate 920mm"). Add the fence height so
  // it reads "Gate 1200mm h × 920mm w" (height follows the Section Height:
  // 1200 / 1500 / 1800). On-screen breakdown only — the PDF/email quote is
  // generated inside the bundle and is not touched here.
  if (on("/pages/blade-fence-calculator")) {
    var lastBladeHeight = null;
    var bladeGateLabels = function () {
      // Detect the Section Height select (3-ish options, value 1000–2100).
      var sels = document.querySelectorAll("#configure-sections select");
      for (var i = 0; i < sels.length; i++) {
        var v = sels[i].value;
        if (sels[i].options.length <= 5 && /^(1000|1200|1500|1800|2100)$/.test(v)) {
          lastBladeHeight = v;
          break;
        }
      }
      if (!lastBladeHeight) return;
      var names = document.querySelectorAll(".quote-breakdown .item-name");
      for (var j = 0; j < names.length; j++) {
        var n = names[j];
        var m = (n.textContent || "").match(/^\s*Gate\s+(\d{3,4})\s*mm\s*$/i);
        if (m) {
          n.textContent = "Gate " + lastBladeHeight + "mm h × " + m[1] + "mm w";
        }
      }
    };
    try {
      var bgMo = new MutationObserver(function () { bladeGateLabels(); });
      bgMo.observe(document.body, { childList: true, subtree: true });
    } catch (_) {}
    document.addEventListener("change", function () { bladeGateLabels(); }, true);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bladeGateLabels);
    } else {
      bladeGateLabels();
    }
  }

  // ── Bug 7: PerfMesh — show "Panel Kits" first in the breakdown ─────────────
  // Ensure the Panel Kits category is the first row of every on-screen breakdown
  // (configure + review). Idempotent no-op when already first. (The PDF/email
  // quote outputs are generated inside the bundle and are not reordered here.)
  if (on("/pages/perfmesh-fence")) {
    var panelKitsFirst = function () {
      var conts = document.querySelectorAll('[id^="breakdown-content"]');
      for (var i = 0; i < conts.length; i++) {
        var cont = conts[i];
        var cats = cont.children;
        var pk = null;
        for (var j = 0; j < cats.length; j++) {
          if (cats[j].className && /breakdown-category/.test(cats[j].className) &&
              /panel kit/i.test(cats[j].textContent || "")) { pk = cats[j]; break; }
        }
        if (pk && cont.firstElementChild !== pk) {
          cont.insertBefore(pk, cont.firstElementChild);
        }
      }
    };
    try {
      var pmMo = new MutationObserver(function () { panelKitsFirst(); });
      pmMo.observe(document.body, { childList: true, subtree: true });
    } catch (_) {}
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", panelKitsFirst);
    } else {
      panelKitsFirst();
    }
  }

  // ── Bug 6: Glass — ask Section Length before Spigot / Mount Type ───────────
  // On the Glass configure step the Spigot/Mount Type field sits above Section
  // Length, forcing customers to pick a spigot before entering their measurement.
  // Move Section Length above Spigot in each section form. Re-applied on
  // re-render; idempotent (only moves when Length is currently after Spigot).
  if (on("/pages/glass-fencing")) {
    var reorderGlass = function () {
      var forms = document.querySelectorAll("#configure-sections .section-form");
      for (var f = 0; f < forms.length; f++) {
        var form = forms[f];
        var groups = form.children;
        var lenG = null, spigotG = null;
        for (var i = 0; i < groups.length; i++) {
          var g = groups[i];
          if (g.className && g.className.toString().indexOf("form-group") === -1) continue;
          if (!lenG && g.querySelector('input[placeholder*="length" i]')) lenG = g;
          var sel = g.querySelector("select");
          if (!spigotG && sel && sel.options[0] && /spigot/i.test(sel.options[0].text || "")) spigotG = g;
        }
        if (lenG && spigotG &&
            (spigotG.compareDocumentPosition(lenG) & Node.DOCUMENT_POSITION_FOLLOWING)) {
          form.insertBefore(lenG, spigotG);
        }
      }
    };
    try {
      var glassMo = new MutationObserver(function () { reorderGlass(); });
      glassMo.observe(document.body, { childList: true, subtree: true });
    } catch (_) {}
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", reorderGlass);
    } else {
      reorderGlass();
    }
  }

  // ── Bug 5: Calculator "Add to Cart" button hidden when DIY pre-selected ────
  // The review step's DIY checkout button (#btn-diy-checkout) ships with a
  // `hidden` class that the bundle only removes inside the pricing-type CHANGE
  // handler. When DIY is already selected on load (the default), that handler
  // never fires, so the button stays hidden and the customer has no way to add
  // to cart (seen on Blade). Reveal it whenever DIY pricing is selected. Safe on
  // every calculator — a no-op where the button is already visible.
  if (
    on("/pages/blade-fence-calculator") ||
    on("/pages/flat-top-fence-calculator") ||
    on("/pages/perfmesh-fence") ||
    on("/pages/glass-fencing")
  ) {
    var syncCheckout = function () {
      var diy = document.getElementById("pricing-diy");
      var btn = document.getElementById("btn-diy-checkout");
      if (btn && diy && diy.checked && btn.classList.contains("hidden")) {
        btn.classList.remove("hidden");
      }
    };
    document.addEventListener("change", function (e) {
      if (e.target && e.target.id && /^pricing-/.test(e.target.id)) syncCheckout();
    }, true);
    try {
      var coMo = new MutationObserver(function () { syncCheckout(); });
      coMo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
    } catch (_) {}
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", syncCheckout);
    } else {
      syncCheckout();
    }
  }

  // ── Bug 4: Cart header count for the "Quote Total" penny-line ──────────────
  // The calculators add the quote total to the cart as a $0.01 product with
  // quantity = total-in-cents. Shopify then reports item_count as that penny
  // quantity, so the header bubble reads e.g. "563,844 items". Show each
  // Quote-Total line as ONE quote instead. Never changes the line quantity
  // itself (that carries the price) — display only.
  (function cartCountFix() {
    var QUOTE = /quote total/i;
    var applying = false;
    var lastCount = null;

    function apply(count) {
      applying = true;
      var label = count + (count === 1 ? " item" : " items");
      var bubbles = document.querySelectorAll(".cart-count-bubble");
      for (var i = 0; i < bubbles.length; i++) {
        bubbles[i].innerHTML =
          '<span aria-hidden="true">' + count + "</span>" +
          '<span class="visually-hidden">' + label + "</span>";
      }
      setTimeout(function () { applying = false; }, 40);
    }

    function refresh() {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var items = c.items || [];
          var inflated = false;
          var count = 0;
          for (var i = 0; i < items.length; i++) {
            var it = items[i];
            var isQuote = QUOTE.test(it.title || it.product_title || "");
            if (isQuote && it.quantity > 1) inflated = true;
            count += isQuote ? 1 : it.quantity;
          }
          lastCount = count;
          if (inflated) apply(count);
        })
        .catch(function () {});
    }

    function boot() {
      refresh();
      var host = document.getElementById("cart-icon-bubble") || document.body;
      try {
        var mo = new MutationObserver(function () {
          if (applying) return;
          var bubble = document.querySelector(".cart-count-bubble");
          if (bubble && /\d{4,}/.test(bubble.textContent) && lastCount != null) {
            apply(lastCount);
          }
          refresh();
        });
        mo.observe(host, { childList: true, subtree: true, characterData: true });
      } catch (_) {}
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  })();


  /* -------------------------------------------------------------------------
   * Bug 9  - Optional Add-ons (Sika grout / base-mount fixing).
   *
   *   (a) FLAT TOP showed NO add-ons at all. Its add-ons feed comes back empty,
   *       and the fallback meant to cover that (an inline script in
   *       layout/theme.liquid) never runs: it ends with a ONE-SHOT
   *       `if (document.querySelector('.calculator-page')) whenReady();`
   *       evaluated during body parse, before the calculator has rendered. The
   *       class is not there yet, so whenReady() is never called and never
   *       retries. Verified live 2026-07-27: addOns = [] and
   *       __claudeGroundPostAddOnsPatched = false. Glass / Blade / PerfMesh are
   *       unaffected because their feed is genuinely populated (2 items each).
   *
   *   (b) That same fallback HARDCODED title and price ($5.00 / $50.47), so a
   *       rename or reprice in Shopify never reached the calculator - silent
   *       pricing drift, and a real risk now the competitor repricing engine is
   *       moving DIY prices.
   *
   * This makes Shopify the single source of truth for both. Reads the two
   * products from live product JSON, then either SEEDS the add-ons list (when
   * empty - the Flat Top case) or CORRECTS existing entries in place (matched
   * on product id, so it can never introduce an item that should not be
   * offered). Relevance filtering - grout for in-ground, fixings for base-mount
   * - is left entirely to each calculator own populateAddOns().
   * Added 2026-07-27; extended same day after live verification.
   * ---------------------------------------------------------------------- */
  (function fixAddOnsUseLiveProductData() {
    if (typeof window.fetch !== "function" || typeof Promise === "undefined") return;

    var CALC_PATHS = [
      "/pages/flat-top-fence-calculator",
      "/pages/blade-fence-calculator",
      "/pages/perfmesh-fence",
      "/pages/glass-fencing",
      "/pages/fence-calculator",
      "/pages/base-mount-batten-calculator"
    ];
    var here = (location.pathname || "").toLowerCase();
    var onCalc = false;
    for (var p = 0; p < CALC_PATHS.length; p++) {
      if (here.indexOf(CALC_PATHS[p]) !== -1) { onCalc = true; break; }
    }
    if (!onCalc) return;

    var HANDLES = ["sika-hes-class-c-rapid-set-grout", "coach-screws"];
    var livePromise = null;

    function loadLive() {
      if (livePromise) return livePromise;
      livePromise = Promise.all(
        HANDLES.map(function (h) {
          return fetch("/products/" + h + ".js", { credentials: "same-origin" })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (results) {
        var out = [];
        for (var i = 0; i < results.length; i++) {
          var prod = results[i];
          if (!prod || !prod.variants || !prod.variants.length) continue;
          var v = prod.variants[0];
          out.push({
            id: prod.id,
            title: prod.title,
            price: (v.price != null ? v.price : prod.price),
            variants: [{
              id: v.id,
              image: (v.featured_image && v.featured_image.src) || prod.featured_image || ""
            }]
          });
        }
        return out;
      });
      return livePromise;
    }

    function sync(calc, live) {
      if (!live || !live.length || !calc.shopifyData) return false;
      if (!calc.shopifyData.collections) calc.shopifyData.collections = {};
      var addOns = calc.shopifyData.collections.addOns;

      // (a) Empty feed -> seed it. This is the Flat Top case.
      if (!Array.isArray(addOns) || addOns.length === 0) {
        calc.shopifyData.collections.addOns = live.slice();
        return true;
      }

      // (b) Populated feed -> correct stale title / price / variant / image.
      var changed = false;
      for (var i = 0; i < live.length; i++) {
        var L = live[i];
        for (var j = 0; j < addOns.length; j++) {
          var item = addOns[j];
          if (Number(item.id) !== Number(L.id)) continue;
          if (item.title !== L.title) { item.title = L.title; changed = true; }
          if (L.price != null && Number(item.price) !== Number(L.price)) {
            item.price = L.price; changed = true;
          }
          if (item.variants && item.variants[0] && L.variants[0]) {
            if (item.variants[0].id !== L.variants[0].id) {
              item.variants[0].id = L.variants[0].id; changed = true;
            }
            if (L.variants[0].image && item.variants[0].image !== L.variants[0].image) {
              item.variants[0].image = L.variants[0].image;
            }
          }
        }
      }
      return changed;
    }

    var ticks = 0;
    (function poll() {
      var calc = window.glassCalculator;
      if (calc && calc.shopifyData) {
        loadLive().then(function (live) {
          if (sync(calc, live) && typeof calc.populateAddOns === "function") {
            try { calc.populateAddOns(); } catch (_) {}
          }
        });
      }
      // Keep watching: sections (and the add-ons panel) are created well after
      // page load, and other code may replace the feed.
      if (ticks++ < 120) setTimeout(poll, 500);
    })();
  })();




})();
